<template>
  <div class="list" name="info">
    <el-card class="codeSearchCard" shadow="never">
      <el-form :inline="true" class="demo-inline-form" :model="search_sale">
        <el-form-item>
          <CascaderDateSelect @changeDateType="changeDateType" @changeDateRange="changeDateRange"></CascaderDateSelect>
        </el-form-item>
        <el-form-item label="激活状态">
          <el-select class="selectWidth" clearable v-model="search_sale.status" placeholder="请选择">
            <el-option :value="0" label="未激活"></el-option>
            <el-option :value="1" label="生效中"></el-option>
            <el-option :value="2" label="待生效"></el-option>
            <el-option :value="3" label="已过期"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <CascaderInputSelect @changeInputType="changeInputType" @changeInputValue="changeInputValue"></CascaderInputSelect>
        </el-form-item>
        <el-form-item label="门店ID">
          <el-input
            class="selectWidth"
            placeholder="请输入商户编号"
            v-model="search_sale.shopId"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input
            class="selectWidth"
            placeholder="请输入商户名称"
            v-model="search_sale.shopName"
            auto-complete="off"></el-input>
        </el-form-item>
        <div>
          <auth-button
            opt="search"
            :plain="true"
            icon="el-icon-search"
            label="查询"
            @click.native="buttonSearch"
            :loading="checkLoading"></auth-button>
        </div>
      </el-form>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <!-- 列表模块 -->
      <el-table
        stripe
        style="border-radius:10px"
        align="center"
        v-loading="saleLoading"
        :data="sale_list">
        <el-table-column
          prop="activationCode"
          label="激活码"
          align="center">
        </el-table-column>
        <el-table-column
          prop="activationServiceName"
          label="软件套餐"
          align="center">
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="激活码状态"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopId"
          label="门店ID"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopName"
          label="门店名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="backgroundOrderId"
          width="100"
          label="订单号"
          align="center">
        </el-table-column>
        <el-table-column
          width="100"
          prop="backgroundPaymentId"
          label="打款单号"
          align="center"
          :formatter="covertPrivilege">
        </el-table-column>
        <el-table-column
          width="95"
          prop="sourceName"
          label="购买渠道"
          align="center">
        </el-table-column>
        <el-table-column
          width="90"
          prop="payAmount"
          label="付款金额"
          align="center">
          <template slot-scope="scope">
            <p>{{ (scope.row.payAmount / 100).toFixed(2) }}</p>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="createTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          width="100"
          prop="useTime"
          label="激活时间"
          align="center">
        </el-table-column>
        <el-table-column
          width="100"
          prop="expireTime"
          label="到期时间"
          align="center">
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        v-if="paginations.total>0"
        class="pagination"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total > 10000 ? 10000 : paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
  </div>
</template>

<script>
import CascaderDateSelect from './components/cascader-date-select'
import CascaderInputSelect from './components/cascader-input-select'
import { merchantActivationCodeList } from '@/api/merchant.js'
export default {
  components: {
    CascaderDateSelect,
    CascaderInputSelect
  },
  data () {
    return {
      isShowOpenScanOrderDialog: false,
      isShowOpenT0SettleDialog: false,
      search_sale: {
        timeType: 1,
        startTime: '',
        endTime: '',
        status: '',
        shopId: '',
        shopName: '',
        conditionType: 1,
        condition: '',
        pageNo: '',
        pageSize: '',
        totalCount: ''
      },
      saleLoading: false, // 列表加载
      checkLoading: false, // 查询加载
      sale_list: [], // 列表数据
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      salesNum: '', // 列表商户总数量
      selectRowId: '' // 当前操作行的商户id
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    changeDateType (val) {
      this.search_sale.timeType = val
    },
    changeDateRange (arr) {
      this.search_sale.startTime = arr[0]
      this.search_sale.endTime = arr[1]
    },
    changeInputType (val) {
      this.search_sale.conditionType = val
    },
    changeInputValue (val) {
      this.search_sale.condition = val
    },
    /**
       * @description 获取列表
       */
    getList () {
      this.saleLoading = true
      var params = this.formatSearch(this.search_sale)
      merchantActivationCodeList(params).then((data) => {
        this.checkLoading = false
        if (data.error_code !== '0') {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          this.saleLoading = false
        } else {
          const { totalNum, activeCodeInfoList } = data.data
          this.saleLoading = false
          this.paginations.total = totalNum
          this.sale_list = activeCodeInfoList
          this.salesNum = totalNum
        }
      }).catch(() => {
        this.saleLoading = false
        this.checkLoading = false
        this.$message({
          showClose: true,
          message: '请求超时，请重新登录',
          type: 'error'
        })
      })
    },
    /**
       * @description 改变当前页事件
       * @param  {number} page 当前页码
       */
    onChangeCurrentPage (page) {
      var totalCount = this.salesNum
      this.search_sale.pageNo = page
      this.search_sale.totalCount = totalCount
      this.getList()
    },
    /**
       * @description 刷新列表，不改变页码等
       */
    onSearch () {
      this.checkLoading = true
      this.getList()
    },
    /**
       * @description 点击查询按钮事件
       */
    buttonSearch () {
      // 当点击查询时，显示第一页
      this.search_sale.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    /**
       * @description 清除对象中无值属性
       */
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        }
      }
      return data
    },
    /**
       * @description 显示查看界面
       */
    handleSale (index, row, scope) {
      this.checkDialogVisible = true
      this.selectRowId = row.fMerchantId
      const query = {
        id: this.selectRowId,
        readOnly: '1',
        isEdit: '0'
      }
      this.$router.push({
        path: '/Merchant/MerchantManage/MerchantDetails',
        query: query
      })
    },
    /**
       * @description 显示编辑界面
       */
    handleEditSale (index, row, scope) {
      this.selectRowId = row.fMerchantId
      const query = {
        id: this.selectRowId,
        readOnly: '0',
        isEdit: '1'
      }
      this.$router.push({
        path: '/Merchant/MerchantManage/MerchantDetails',
        query: query
      })
    }
  }
}
</script>

<style scoped>
  .list{
    padding-left: 16px;
  }
  .btm-action {
    margin: 20px 0;
    text-align: center;
  }
  .pagination {
    display: inline-block;
  }
  .btmBtn{
    margin-top: 10px;
  }
</style>
